module.exports = __webpack_public_path__ + "assets/icons/ic_battery_healthy.svg";